export const langCodeToIdMap: Record<string, string> = {
	'1': 'HI',
	'2': 'EN',
	'3': 'MR',
};
